export default {
    workerDeliveryFeeGroupList: [],
    workerCashAutoDeductGroupList: [],
    workerPenaltyGroupList: [],
};
